// Standalone Colors for PDF export/PDF generation
// Uses hardcoded values because CSS variables are not available in Node.js context

export const Colors = {
	main1: "#13c892",
	main2: "#FF5A8A",
	main3: "#FF9D42",
	main4: "#A855F7",
	main1light: "#e8f9f4",
	main2light: "#ffeef3",
	main3light: "#fff4eb",
	main4light: "#f3e8ff",
	error: "#FF5A5A",
	black: "#222222",
	mainBlack: "#222222",
	white: "#ffffff",
	greyDark: "#666666",
	greyLight: "#999999",
	greyBorder: "#e5e5e5",
	bgDark: "#E8EFF5",
	bgMedium: "#F0F5FA",
	bgLight: "#F8FAFC",
};

export const getItemIcon = (type: string) =>
	type === "accommodation"
		? "bed--outlined"
		: type === "activity"
			? "todo--outlined"
			: type === "cuisine"
				? "cuisine"
				: type === "tour"
					? "tour"
					: type === "transport"
						? "transport--outlined"
						: type === "city"
							? "marker"
							: type === "destination"
								? "scratchGlobe"
								: "article";

export const B2C_COLORS = {
	PRIMARY: "#13c892",
	SLEEP: "#13c892",
	TRANSPORT: "#ea5681",
	SEE_DO: "#ffc14a",
	EAT_DRINK: "#6237dd",
};

export const B2B_COLORS = {
	PRIMARY: "#1b3d49",
	SLEEP: "#818cf8",
	TRANSPORT: "#7c3aed",
	SEE_DO: "#00d4aa",
	EAT_DRINK: "#e979f9",
};

export const DEFAULT_B2B_THEME = {
	BRAND_PRIMARY: B2B_COLORS.PRIMARY,
	BRAND_SECONDARY: B2B_COLORS.SEE_DO,
};
